/* Roadvance: make the store badges and community logo printed inside banner images clickable */
(function () {
  var PLAY = 'https://play.google.com/store/apps/details?id=com.roadvance.app.prod';
  var IOS = 'https://apps.apple.com/in/app/roadvance/id6749842129';
  var COMMUNITY = location.pathname.indexOf('/pages/our-story') === 0 ? 'https://www.instagram.com/safecars_india/' : '/pages/our-story';
  // [left, top, width, height] in % of the image
  var MAP = {
    'website-01.png': [[13.4, 79.2, 12.8, 5.9, PLAY, 'Get it on Google Play'], [27.5, 79.2, 12.7, 5.9, IOS, 'Download on the App Store']],
    'website-05.png': [[26.5, 88.8, 23.3, 5.0, PLAY, 'Get it on Google Play'], [51.9, 88.8, 23.1, 5.0, IOS, 'Download on the App Store']],
    'website-03.png': [[8.2, 68.4, 44.5, 14.6, COMMUNITY, 'Roadvance x Safe Cars India community']],
    'website-06.png': [[15.0, 82.6, 70.0, 10.8, COMMUNITY, 'Roadvance x Safe Cars India community']]
  };
  function key(img) {
    var s = img.currentSrc || img.src || '';
    for (var k in MAP) if (s.indexOf('/' + k) > -1) return k;
    return null;
  }
  function draw() {
    document.querySelectorAll('.banner picture img').forEach(function (img) {
      var banner = img.closest('.banner');
      if (!banner) return;
      var k = key(img);
      var layer = banner.querySelector(':scope > .rv-hotspots');
      if (!k) { if (layer) layer.remove(); return; }
      if (layer && layer.dataset.k === k) return;
      if (!layer) { layer = document.createElement('div'); layer.className = 'rv-hotspots'; banner.appendChild(layer); }
      layer.dataset.k = k;
      layer.innerHTML = '';
      MAP[k].forEach(function (h) {
        var a = document.createElement('a');
        a.href = h[4]; a.setAttribute('aria-label', h[5]); a.title = h[5];
        if (h[4].indexOf('http') === 0) { a.target = '_blank'; a.rel = 'noopener'; }
        a.style.cssText = 'left:' + h[0] + '%;top:' + h[1] + '%;width:' + h[2] + '%;height:' + h[3] + '%';
        layer.appendChild(a);
      });
    });
  }
  function run() { draw(); setTimeout(draw, 800); setTimeout(draw, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', draw);
  window.addEventListener('resize', function () { clearTimeout(window.__rvT); window.__rvT = setTimeout(draw, 200); });
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') draw(); }, true);
})();
